module.exports = __webpack_public_path__ + "img/stena18.b4c053b5.jpg";